<template>
  <div class="page-membres" data-model-id="3141:822">
    <div class="background-image-wrapper">
      <div class="background-image">
          <img
            class="freepik-expand"
            alt="Freepik expand"
            src="/img/freepik-green-long-grass.png"
          />
        <div class="background-overlay" /> 
        <div class="background" />
      </div>
    </div>
    <div class="main-container">
      <header>
        <div class='burger-wrapper' v-show="tmode || mmode">
          <button class="burger-button" @click="toggleMobileMenu">
            <div class='line1' :class="{ 'active': mobileMenuOpen }"></div>
            <div class='line2' :class="{ 'active': mobileMenuOpen }"></div>
          </button>
        </div>
        
        <div class="navbar" v-show="wsmode">
          <router-link to="/" class="navbar-item">
            <span class="nav-text">Accueil</span>
            <div class="nav-underline"></div>
          </router-link>
          <router-link to="/about" class="navbar-item">
            <span class="nav-text">Symabio</span>
            <div class="nav-underline"></div>
          </router-link>
          <router-link to="/pagemembres" class="navbar-item">
            <span class="nav-text">Membres</span>
            <div class="nav-underline"></div>
          </router-link>
          <router-link to="/reglement" class="navbar-item">
            <span class="nav-text">Réglementations</span>
            <div class="nav-underline"></div>
          </router-link>
        </div>

        <!-- Mobile Menu -->
        <div class="mobile-menu-overlay" v-show="mobileMenuOpen" @click="closeMobileMenu"></div>
        <div class="mobile-menu" :class="{ 'active': mobileMenuOpen }" v-show="tmode || mmode">
          <div class="mobile-menu-header">
            <img src="/img/logo-symabio.png" alt="Logo Symabio" class="mobile-logo" />
          </div>
          <div class="mobile-menu-links">
            <router-link to="/" class="mobile-navbar-item" @click="closeMobileMenu">Accueil</router-link>
            <router-link to="/about" class="mobile-navbar-item" @click="closeMobileMenu">Symabio</router-link>
            <router-link to="/pagemembres" class="mobile-navbar-item" @click="closeMobileMenu">Membres</router-link>
            <router-link to="/reglement" class="mobile-navbar-item" @click="closeMobileMenu">Réglementations</router-link>
          </div>
          <div class="mobile-menu-footer">
            <div class="social-icons">
              <a href="#" class="social-icon"><img src="/img/gg-facebook.svg" alt="Facebook"></a>
              <a href="#" class="social-icon"><img src="/img/formkit-linkedin.svg" alt="LinkedIn"></a>
              <a href="#" class="social-icon"><img src="/img/akar-icons-instagram-fill.svg" alt="Instagram"></a>
            </div>
          </div>
        </div>

        <router-link to="/" class="logo">
          <img
          class="logo-symabio"
          alt="Logo symabio"
          src="/img/logo-symabio.png"
          />
        </router-link>
      </header>
      <div class="content-flex">
        <div class="subtitle">Les membres de Symabio</div>
        <div class="searchbar">
          <div class="input-container">
            <input 
              type="text" 
              placeholder="Recherche..."
              v-model="searchQuery"
              @input="handleSearchInput"
              @focus="showSearchResults = true"
            />
            <div v-if="showSearchResults && (searchResults.length > 0 || productResults.length > 0)" class="search-results-container">
              <!-- Products Section -->
              <div v-if="productResults.length > 0" class="search-section products-section">
                <div class="search-section-title">🌿 PRODUITS BIO</div>
                <div class="search-results-wrapper">
                  <ul class="search-results-list">
                    <li 
                      v-for="result in productResults" 
                      :key="`product-${result.memberNumero}-${result.productName}`"
                      @click="navigateToMember(result.memberNumero)"
                      class="product-item"
                    >
                      <div class="product-content">
                        <img 
                          v-if="result.productImage"
                          :src="`/produits/${result.memberNumero}/${result.productImage}`"
                          :alt="result.productName"
                          class="product-image"
                          @error="handleProductImageError($event)"
                        />
                        <div v-else class="product-image-placeholder">
                          <span>📦</span>
                        </div>
                        <div class="product-text">
                          <span class="product-name">{{ result.productName }}</span>
                          <span class="member-name">de {{ result.memberName }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              
              <!-- Members Section -->
              <div v-if="searchResults.length > 0" class="search-section members-section">
                <div class="search-section-title">🏢 ENTREPRISES</div>
                <div class="search-results-wrapper">
                  <ul class="search-results-list">
                    <li 
                      v-for="result in searchResults" 
                      :key="result.Numero"
                      @click="navigateToMember(result.Numero)"
                    >
                      {{ result['Nom de la société'] }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="search-button" @click="performSearch">
            <div class="mingcute-search-line">
              <img class="icon-search" alt="Search" src="/img/group-1.png" height="24"/>
            </div>
          </div>
        </div>
      </div>
      <ZonesAndProducts @zone-selected="updateSelectedZone" @category-selected="handleCategorySelected" />
      <div class="divider"></div>
      <MembersCards :selected-zone="selectedZone" :selected-product-category="selectedProductCategory" />
    </div>
  </div>
</template>

<script>
import ZonesAndProducts from "./PageMembres/sections/ZonesAndProducts.vue";
import MembersCards from "./PageMembres/sections/MembersCards.vue";
import allMembresData from "@/membres.json"; // Import all members data
import productsZonesData from "@/products-zones.json"; // Import products and zones data

export default {
  name: "PageMembres",
  components: {
    ZonesAndProducts,
    MembersCards,
  },
  data() {
    return {
      selectedZone: null,
      selectedProductCategory: null,
      searchQuery: '',
      searchResults: [],
      productResults: [],
      showSearchResults: false,
      allMembers: allMembresData, // Store all members for searching
      productsZones: productsZonesData, // Store products and zones data
      mobileMenuOpen: false,
    };
  },
  props:{
    wsmode:{
      type: Boolean,
      default: false
    },
    tmode:{
      type: Boolean,
      default: false
    },
    mmode:{
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log("PageMembres.vue component has been mounted!");
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() { // Vue 3 syntax, use beforeDestroy for Vue 2
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    updateSelectedZone(zone) {
      this.selectedZone = zone === null ? '' : zone;
      // Optionally, clear search when zone changes or integrate search with zone filter
      this.searchQuery = ''; 
      this.searchResults = [];
      this.productResults = [];
      this.showSearchResults = false;
    },
    handleZoneSelected(zone) {
      this.selectedZone = zone;
    },
    handleCategorySelected(category) {
      this.selectedProductCategory = category === null ? '' : category;
      // Optionally, clear search when category changes
      this.searchQuery = ''; 
      this.searchResults = [];
      this.productResults = [];
      this.showSearchResults = false;
    },
    handleSearchInput() {
      if (this.searchQuery.length > 1) { // Start searching after 2 characters
        this.performSearch();
        this.showSearchResults = true;
      } else {
        this.searchResults = [];
        this.productResults = [];
        this.showSearchResults = false;
      }
    },
    performSearch() {
      if (!this.searchQuery) {
        this.searchResults = [];
        this.productResults = [];
        this.showSearchResults = false;
        return;
      }
      const lowerQuery = this.searchQuery.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      
      // Search in members (existing functionality)
      this.searchResults = this.allMembers.filter(member => {
        const nom = (member['Nom de la société'] || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        
        // Only search by company name
        return nom.includes(lowerQuery);
      });

      // Search in products from products-zones.json
      this.productResults = [];
      this.productsZones.forEach(member => {
        if (member['Produits BIO'] && Array.isArray(member['Produits BIO'])) {
          member['Produits BIO'].forEach(product => {
            const productName = product.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            
            // Only search by product name, not member name
            const productMatches = productName.startsWith(lowerQuery) || 
                                 productName.includes(' ' + lowerQuery) ||
                                 productName === lowerQuery;
            
            if (productMatches) {
              // Find matching product image - much more precise matching
              let productImage = null;
              if (member['Images Produits'] && Array.isArray(member['Images Produits'])) {
                // Look for image that specifically matches this product
                productImage = member['Images Produits'].find(imageName => {
                  const imageNameLower = imageName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                  const productNameLower = product.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                  
                  // Remove common words and get key product name parts
                  const productKeywords = productNameLower.split(' ').filter(word => 
                    word.length > 2 && !['de', 'du', 'des', 'le', 'la', 'les', 'et', 'ou'].includes(word)
                  );
                  
                  // Check if image name contains the main product keywords
                  if (productKeywords.length > 0) {
                    const mainKeyword = productKeywords[0]; // Use the first significant word
                    return imageNameLower.includes(mainKeyword) && 
                           (imageNameLower.includes(`${member['Numero']}-${mainKeyword}`) ||
                            imageNameLower.includes(`-${mainKeyword}`) ||
                            imageNameLower.startsWith(mainKeyword));
                  }
                  
                  return false;
                });
              }
              
              this.productResults.push({
                productName: product,
                memberName: member['Nom'],
                memberNumero: member['Numero'],
                zone: member['Zone'],
                productImage: productImage
              });
            }
          });
        }
      });

      this.showSearchResults = this.searchResults.length > 0 || this.productResults.length > 0;
    },
    navigateToMember(numero) {
      if (numero) {
        this.$router.push(`/detailsMembres/${numero}`);
        this.showSearchResults = false; // Hide results after navigation
        this.searchQuery = ''; // Clear search query
        this.searchResults = [];
        this.productResults = [];
      }
    },
    // Add a method to hide search results when clicking outside
    handleClickOutside(event) {
      const searchbarElement = this.$el.querySelector('.searchbar .input-container');
      if (searchbarElement && !searchbarElement.contains(event.target)) {
         this.showSearchResults = false;
      }
    },
    handleProductImageError(event) {
      // Hide the image and show placeholder when image fails to load
      event.target.style.display = 'none';
      const placeholder = event.target.nextElementSibling;
      if (placeholder && placeholder.classList.contains('product-image-placeholder')) {
        placeholder.style.display = 'flex';
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.classList.remove('no-scroll');
    }
  },
};
</script>

<style>
.page-membres {
  height: 100vh;
  margin: 0;
  padding: 0;
  position: absolute;
}

.page-membres header{
  /* background: linear-gradient(to bottom,#e6e3b5,#e6e3b5) ; */
  background: linear-gradient(to right, #c5c69c, #cdc99c, #ceca9c) ;
  /* background: #ceca9c ; */
  position: fixed;
  height: 120px;
  top:0;
  display: flex;
  flex: 1;
  width: 100%;
  z-index: 99;

}
.page-membres .burger-wrapper {
  z-index: 1000;
  position: absolute;
  right: 2vw;
  top: 56px;
}
.page-membres .burger-button {
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-end ;
  justify-content: center;
  gap:6px;
  cursor: pointer;
  background: none;
  border: none;
}
.page-membres .line1,.page-membres .line2{
  border-radius: 2px;
  background: #3b723e;
  height: 3.1px;
  transition: width 0.5s ease-in-out, transform 0.5s ease-in-out;
}
.page-membres .line1{
  width: 40px;
}
.page-membres .line2{
  width: 30px;
}

.page-membres .line1.active {
  transform: rotate(45deg) translate(6px, 6px);
}
.page-membres .line2.active {
  transform: rotate(-45deg) translate(7px, -7px);
  width: 40px;
}

/* Mobile Menu */
.page-membres .mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

.page-membres .mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 300px;
  height: 100vh;
  background: #fff;
  z-index: 999;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
}

.page-membres .mobile-menu.active {
  right: 0;
}

.page-membres .mobile-menu-header {
  padding: 24px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.page-membres .mobile-logo {
  height: 60px;
  width: auto;
}

.page-membres .mobile-menu-links {
  flex: 1;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.page-membres .mobile-navbar-item {
  display: block;
  padding: 16px 24px;
  color: #000;
  text-decoration: none;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 18px;
  font-weight: 300;
  border-bottom: 1px solid #f5f5f5;
  transition: background-color 0.2s ease;
}

.page-membres .mobile-navbar-item:hover {
  background-color: #f8f9fa;
}

.page-membres .mobile-navbar-item.router-link-active {
  background-color: #3b723e;
  color: white;
}

.page-membres .mobile-menu-footer {
  padding: 24px;
  border-top: 1px solid #eee;
}

.page-membres .social-icons {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.page-membres .social-icon {
  display: block;
  width: 32px;
  height: 32px;
}

.page-membres .social-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Global no-scroll class */
.no-scroll {
  overflow: hidden;
}
/* header logo navbar  */
.page-membres .navbar {
  align-items: center;
  display: inline-flex;
  gap: 4vw;
  right: 3vw;
  position: fixed;
  top: 52px;
}

.page-membres .navbar-item {
  color: rgba(0, 0, 0, 0.85);
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.5px;
  line-height: 24px;
  text-decoration: none;
  white-space: nowrap;
  width: fit-content;
  position: relative;
  padding: 8px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.page-membres .nav-text {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.page-membres .nav-underline {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b723e, #4caf50, #66bb6a);
  transform: translateX(-50%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(59, 114, 62, 0.4);
}

/* Normal hover effect */
.page-membres .navbar-item:hover {
  color: #000000;
  transform: translateY(-1px);
}

.page-membres .navbar-item:hover .nav-underline {
  width: 100%;
  box-shadow: 0 4px 12px rgba(59, 114, 62, 0.6);
}

.page-membres .navbar-item:hover .nav-text {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Active page styling (router-link-active) */
.page-membres .navbar-item.router-link-active {
  color: #3b723e;
  font-weight: 500;
  transform: translateY(-1px);
}

.page-membres .navbar-item.router-link-active .nav-text {
  text-shadow: 0 2px 12px rgba(59, 114, 62, 0.2);
  background: linear-gradient(135deg, #3b723e, #4caf50);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-membres .navbar-item.router-link-active .nav-underline {
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #3b723e, #4caf50, #66bb6a, #4caf50, #3b723e);
  background-size: 200% 100%;
  animation: shimmer 2s ease-in-out infinite;
  box-shadow: 
    0 2px 8px rgba(59, 114, 62, 0.6),
    0 0 20px rgba(76, 175, 80, 0.3);
}

.page-membres .navbar-item.router-link-active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(59, 114, 62, 0.05) 0%, transparent 70%);
  border-radius: 8px;
  z-index: 1;
  opacity: 0;
  animation: glow 2s ease-in-out infinite alternate;
}

/* Enhanced hover effect for active page */
.page-membres .navbar-item.router-link-active:hover {
  transform: translateY(-2px);
}

.page-membres .navbar-item.router-link-active:hover .nav-text {
  text-shadow: 0 4px 16px rgba(59, 114, 62, 0.3);
}

.page-membres .navbar-item.router-link-active:hover .nav-underline {
  height: 4px;
  box-shadow: 
    0 4px 16px rgba(59, 114, 62, 0.8),
    0 0 30px rgba(76, 175, 80, 0.5);
}

/* Animations */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes glow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.page-membres .logo {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  left: 7vw;
  padding: 10px;
  position: fixed;
  top: 24px;
}

.page-membres .logo-symabio {
  align-self: stretch;
  height: 64px;
  object-fit: cover;
  position: relative;
  width: 100%;
}

.page-membres .background-image-wrapper {
  position: fixed;
  background: #e6e3b5;
  height: 100vh;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: -999;
}

.page-membres .background-image {
  height: 100%;
}
.page-membres .freepik-expand {
  opacity: 0.24;
  object-fit: cover;
  position: fixed;
  top: 0;
  width: -webkit-fill-available;
  animation: parallax 3s ease-in;
}

@keyframes parallax {
  0%{
    scale: 1.5;
  }
  100%{
    scale: 1;
  }
}

.page-membres .background-overlay {
  background: #01010114;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.page-membres .background {
  mix-blend-mode: multiply;
  background: #e6e3b57d;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
}

.page-membres .main-container{
  /* background-color: white; */
  padding-top: 32px;
  height: 100%;
  width: 100vw;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: 0;
  scrollbar-color: rgba(76, 175, 79, 0.01) transparent;
  /* overflow-x: hidden; */
  scrollbar-width: none;
}
/* Chrome, Edge, Safari */
.page-membres .overlap::-webkit-scrollbar {
  width: 8px;
}

.page-membres .overlap::-webkit-scrollbar-track {
  background: transparent;
}

.page-membres .overlap::-webkit-scrollbar-thumb {
  background: #4caf50;
  border-radius: 4px;
}
.page-membres .content-flex {
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
  margin: 20vh 8vw 24px 8vw;
}
.page-membres .subtitle {
  color: #3b723e;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 4vw;
  font-weight: 300;
  letter-spacing: 0;
  line-height: normal;
  white-space: nowrap;
}
.page-membres .searchbar {
  z-index: 1;
  align-items: center;
  display: flex;
  gap: 6px;
  width: 36%;
  align-items: center;
  display: flex;
  gap:12px;
}

.page-membres .input-container {
  width: -webkit-fill-available;
  position: relative; /* For positioning the results container */
}
.page-membres .input-container input {
    border: none;
    background: #e1e6d5cc;
    /* border-radius: 17px 17px 17px 17px; */
    width: -webkit-fill-available;
    height: 64px;
    font-size: 20px;
    font-weight: 300;
    color: #3b723e;
    text-indent: 24px;
    outline-color: #72703b;
    outline-width: 2px;
    position: relative;
}

.search-results-list {
    list-style-type: none;
    margin-top: 0px;
    margin-left: -1px;
    padding: 0px;
    /* margin: 0; */
    position: absolute;
    background-color: #e1e6d5c7 !important;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0 0 0 0 !important;
    width: calc(100% - -2px);
    max-height: 223px !important;
    overflow-y: auto;
}

.search-results-container {
position: absolute;
    width: 508px;
    top: 100%;
    left: -1px;
    right: 0;
    background-color: #e1e6d5cc;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0 0 16px 16px;
    max-height: 430px;
    overflow-y: visible;
    z-index: 1000;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.search-section {
    /* background-color: #ffffff; */
margin-bottom: 221px;
}

.members-section {
    border-top: 2px solid #f0f0f0;
}

.search-results-wrapper {
    background-color: #ffffff;
    overflow: hidden;
}

.search-section-title {
    padding: 14px 24px;
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 0;
    position: sticky;
    top: 0;
    z-index: 10;
}

.products-section .search-section-title {
    /* background: linear-gradient(135deg, #4caf50, #66bb6a); */
    color: #000000;
    /* border-bottom: 1px solid #43a047; */
}

.members-section .search-section-title {
    background: linear-gradient(135deg, #3b723e, #4e8b52);
    color: #ffffff;
    /* border-bottom: 1px solid #2e5a31; */
}

.search-results-list li {
  padding: 14px 24px;
  cursor: pointer;
  color: #3b723e;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: all 0.2s ease;
  position: relative;
}

.product-item .search-results-list li,
.product-item {
  padding: 12px 24px;
}

.product-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.product-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.product-image-placeholder {
  width: 40px;
  height: 40px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #999;
  flex-shrink: 0;
}

.product-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.search-results-list li:last-child {
  border-bottom: none;
}

.products-section .search-results-list li:hover {
  background-color: #f1f8e9;
  border-left: 4px solid #4caf50;
  padding-left: 20px;
}

.members-section .search-results-list li:hover {
  background-color: #f3f7f4;
  border-left: 4px solid #3b723e;
  padding-left: 20px;
}

.product-name {
  font-weight: 600;
  color: #2e7d32;
  font-size: 14px;
}

.member-name {
  font-size: 11px;
  color: #757575;
  font-style: italic;
  margin-left: 0;
}

.page-membres .input-container input::placeholder{
  color: #3b723e;
  font-weight: 200;
}

.page-membres .search-button {
  background: #3b723e;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
  width: 72px;
}

.page-membres .mingcute-search-line {
  height: 24px;
  position: relative;
  width: 24px;
}
.page-membres .divider{
  height: 4vh;
}
@media (max-height: 1200px){
  .page-membres .freepik-expand {
    height: -webkit-fill-available;
    animation: parallax 2s ease-in;
  }
}

@media (max-width: 1024px){
  .page-membres .content-flex {
    margin: 132px 4vw 24px 4vw;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    overflow: visible;
  }
  
  .page-membres .subtitle {
    font-size: 6vw;
    width: 100%;
    text-align: center;
    white-space: normal;
  }
  
  .page-membres .searchbar {
    width: 100%;
    max-width: 500px;
    overflow: visible;
  }
  
  .search-results-container {
    width: 100%;
    left: 0;
    right: 0;
  }
}

@media (max-width: 773px){
  .page-membres .content-flex {
    margin: 132px 6vw 24px 6vw;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
  
  .page-membres .subtitle {
    font-size: 28px;
    width: 100%;
    text-align: center;
    white-space: normal;
  }
  
  .page-membres .searchbar {
    width: 100%;
    max-width: 400px;
  }
  
  .page-membres .input-container input {
    height: 56px;
    font-size: 18px;
  }
  
  .page-membres .search-button {
    height: 54px;
    width: 64px;
  }
}

@media (max-width: 480px){
  .page-membres .content-flex {
    margin: 120px 4vw 20px 4vw;
    gap: 8px;
  }
  
  .page-membres .subtitle {
    font-size: 24px;
  }
  
  .page-membres .searchbar {
    width: 100%;
    max-width: 350px;
  }
  
  .page-membres .input-container input {
    height: 52px;
    font-size: 16px;
    text-indent: 20px;
  }
  
  .page-membres .search-button {
    height: 50px;
    width: 60px;
  }
  
  .search-results-container {
    max-height: 250px;
    border-radius: 0 0 12px 12px;
  }
  
  .search-section-title {
    padding: 12px 20px;
    font-size: 11px;
  }
  
  .search-results-list li {
    padding: 12px 20px;
  }
  
  .product-content {
    gap: 8px;
  }
  
  .product-image,
  .product-image-placeholder {
    width: 32px;
    height: 32px;
  }
  
  .product-name {
    font-size: 13px;
  }
  
  .member-name {
    font-size: 10px;
  }
}
</style>